// DO NOT MODIFY - this file is auto-generated by build-icons.js
// @ts-nocheck
import React from 'react';
import Icon from '../shared/icon';

/* eslint-disable react/jsx-max-props-per-line,react/jsx-space-before-closing,react/jsx-tag-spacing */

const CloseIcon = (props) => (
  <Icon {...props}>
    {
      ({ color, width, height }) => (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 58 58">
          <path fill="inherit" d="M29 3.61c6.777 0 13.15 2.64 17.943 7.433 4.792 4.792 7.432 11.165 7.432 17.943 0 6.777-2.64 13.15-7.432 17.942C42.15 51.72 35.777 54.36 29 54.36c-6.778 0-13.15-2.64-17.943-7.433-4.792-4.792-7.432-11.165-7.432-17.942 0-6.778 2.64-13.15 7.432-17.943C15.85 6.25 22.222 3.61 29 3.61m0-3.625c-16.016 0-29 12.983-29 29 0 16.016 12.984 29 29 29 16.017 0 29-12.984 29-29s-12.983-29-29-29zm5.127 29l8.312-8.312a3.626 3.626 0 0 0-5.128-5.126L29 23.857l-8.312-8.31a3.624 3.624 0 0 0-5.126 0 3.624 3.624 0 0 0 0 5.125l8.312 8.312-8.312 8.312a3.624 3.624 0 1 0 5.126 5.126L29 34.112l8.312 8.31c.708.71 1.636 1.063 2.563 1.063s1.855-.354 2.563-1.062a3.626 3.626 0 0 0 0-5.126l-8.31-8.312z"/>
        </svg>
      )
    }
  </Icon>
);

export default CloseIcon;
